// extracted by mini-css-extract-plugin
export default {"invite-member":"zz4Ff3K8NT8nWXg8qgTO"};